import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdminInvoiceService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  generateTicketInvoice(ticketId): Observable<any> {
    const route = `${this.configUrl}i/g/ticket/${ticketId?.toString()}`;
    return this.http.get(route)
      .pipe(
        first(),
      );
  }

  generateAutoPurchaseInvoice(waitListPurchaseId): Observable<any> {
    const route = `${this.configUrl}i/g/autopurchase/${waitListPurchaseId?.toString()}`;
    return this.http.get(route)
      .pipe(
        first(),
      );
  }

  exportFilteredInvoices(filters): Observable<ArrayBuffer> {
    const route = `${this.configUrl}exploreInvoices`;
    Object.keys(filters).forEach((x) => {
      if (filters[x] === null) {
        filters[x] = '';
      }
    });
    const params = new HttpParams({
      fromObject: {
        format: 'csv',
        ...filters,
      },
    });
    return this.http.get(route, {params, responseType: 'arraybuffer'}).pipe(
      map((file: ArrayBuffer) => file),
    );
  }

}
